import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  demo: false,
  backendPort: null,
  googleTagManagerId: 'GTM-K2GL6QG',
};
